var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16M4 7h16a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V9a2 2 0 012-2z",
    stroke: "#37383E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDIxVjVDMTYgNC40Njk1NyAxNS43ODkzIDMuOTYwODYgMTUuNDE0MiAzLjU4NTc5QzE1LjAzOTEgMy4yMTA3MSAxNC41MzA0IDMgMTQgM0gxMEM5LjQ2OTU3IDMgOC45NjA4NiAzLjIxMDcxIDguNTg1NzkgMy41ODU3OUM4LjIxMDcxIDMuOTYwODYgOCA0LjQ2OTU3IDggNVYyMU00IDdIMjBDMjEuMTA0NiA3IDIyIDcuODk1NDMgMjIgOVYxOUMyMiAyMC4xMDQ2IDIxLjEwNDYgMjEgMjAgMjFINEMyLjg5NTQzIDIxIDIgMjAuMTA0NiAyIDE5VjlDMiA3Ljg5NTQzIDIuODk1NDMgNyA0IDdaIiBzdHJva2U9IiMzNzM4M0UiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgBriefcase as ReactComponent };